// UNA SOLA FONTE PER LA VERSIONE.
// La versione la dichiara la pubblicazione (`/downloads/latest.json`, firmata insieme
// all'APK), non una stringa scritta a mano in quattro file diversi: così il sito non può
// più annunciare una versione vecchia il giorno dopo una pubblicazione.
// Se la lettura non riesce (offline, cache) resta il valore di riserva: mai una schermata
// vuota al posto di un numero.
import { useEffect, useState } from "react";

export const CODENAME = "The Sovereign Seed";
const RISERVA = "3.7.9";
let ricordata = null;

// LA VERSIONE DELLA RETE (v7.4.4). L'app e la rete sono due cose diverse: la rete si
// aggiorna quando si aggiornano i nodi, l'app quando si pubblica un APK. Mostrarne una
// sola faceva sembrare vecchio tutto l'insieme. Questa legge /version.json, firmato.
let reteRicordata = null;

export function useNetworkVersion() {
  const [v, setV] = useState(reteRicordata || "");
  useEffect(() => {
    if (reteRicordata) return;
    let vivo = true;
    fetch("/version.json", { cache: "no-store" })
      .then((r) => r.json())
      .then((j) => {
        const n = j && j.rete;
        if (!n) return;
        reteRicordata = String(n);
        if (vivo) setV(reteRicordata);
      })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);
  return v;
}

export function useAppVersion() {
  const [v, setV] = useState(ricordata || RISERVA);
  useEffect(() => {
    if (ricordata) return;
    let vivo = true;
    fetch("/downloads/latest.json", { cache: "no-store" })
      .then((r) => r.json())
      .then((j) => {
        const n = j && j.versionName;
        if (!n) return;
        ricordata = String(n);
        if (vivo) setV(ricordata);
      })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);
  return v;
}
